module.exports = __webpack_public_path__ + "static/media/folder-times.03a30df9.svg";